import React from 'react';
import styles from './quotationMark.scss';

const QuotationMark = () => {
  return <span className={styles.quotationMark}>”</span>;
};

export default QuotationMark;
